export default (val) => {
  if (!val) {
    return '';
  }

  const value = val.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};



// WEBPACK FOOTER //
// ./src/filter/capitalize.js